const WEIGHTS = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];

/** Da formato XX-XXXXXXXX-X mientras se escribe. */
export function formatCuil(value: string): string {
  const d = value.replace(/\D/g, '').slice(0, 11);
  if (d.length <= 2) return d;
  if (d.length <= 10) return `${d.slice(0, 2)}-${d.slice(2)}`;
  return `${d.slice(0, 2)}-${d.slice(2, 10)}-${d.slice(10)}`;
}

/** Valida el dígito verificador del CUIL/CUIT. */
export function isValidCuil(value: string): boolean {
  const d = value.replace(/\D/g, '');
  if (d.length !== 11) return false;
  const sum = WEIGHTS.reduce((acc, w, i) => acc + w * Number(d[i]), 0);
  const mod = 11 - (sum % 11);
  const check = mod === 11 ? 0 : mod === 10 ? 9 : mod;
  return check === Number(d[10]);
}
